module.exports = __webpack_public_path__ + "assets/img/swzq.2a0c0831.png";